<template>
  <div class="user-info">
    <div class="user-info-top">
      <div class="user-info-top__left">
        <!-- Thông báo -->
        <Notification></Notification>
        <!-- Chat -->
        <!-- <Chat></Chat> -->
      </div>
      <div class="user-info-top__right">
        <!-- User Dropdown -->
        <!-- <el-dropdown trigger="click">
          <div class="el-dropdown-link">
            <div class="user-avatar">
              <el-avatar :size="38" :src="ExtensionService.urlImg + userInfo.avatarId"></el-avatar>
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
        </el-dropdown> -->
      </div>
    </div>
    <div class="user-info-main">
      <!-- Ảnh đại diện -->
      <div class="user-avatar" @click="goToProfile()">
        <el-image
          :src="
            userInfo.avatarId
              ? ExtensionService.urlImg + userInfo.avatarId
              : 'img/company.jpg'
          "
          fit="cover"
        />
        <!-- <el-avatar
          :size="90"
          :src="
            userInfo.avatarId
            ? ExtensionService.urlImg + userInfo.avatarId
            : 'img/company.jpg'
          "
        /> -->
      </div>
      <!-- Tên , chức vụ -->
      <p class="name" @click="goToProfile()">{{userInfo.name}}</p>
      <p class="position">{{userInfo.position}}</p>
    </div>
    <div class="user-info-contact">
      <!-- Số điện thoại -->
      <div class="user-info-contact__text">
        <span class="type">SĐT</span>
        <span :title="userInfo.phone" class="text phone">{{userInfo.phone}}</span>
      </div>
      <!-- Email -->
      <div class="user-info-contact__text">
        <span class="type">Email</span>
        <span :title="userInfo.email" class="text email">{{userInfo.email}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import Notification from './Notification';
import Chat from './Chat';
import MethodService from '../service/MethodService';
import ExtensionService from '../service/ExtensionService';
export default {
  components: {
    Notification,
    Chat
  },
  data() {
    return {
      ExtensionService,
      isCompany: false,
      userInfo: {
        name: undefined,
        position: undefined,
        phone: undefined,
        email: undefined,
        avatarId: undefined,
      },
      userPofile: MethodService.getUserProfile(),
      companyInfo: MethodService.getCompanyInfo(),
      employeeInfo: MethodService.getEmployeeInfo()
    }
  },
  methods: {
    goToProfile() {
      if (this.isCompany) {
        let company = MethodService.getCompanyInfo();
        this.$router.push({
          name: "Admin-CompanyInfo-detail",
          params: {id: company.id}
        })
      } else {
        let currentUser = MethodService.getCurrentUser();
        this.$router.push({
          name: "Admin-EmployeeInfo-detail",
          params: {id: currentUser.id}
        })
      }
    },
    getUserInfo() {
      this.userInfo = {
        name: this.userPofile.name.full_name,
        email: this.userPofile.email,
        phone: this.userPofile.phone_number
      }
      if (this.userPofile.type && this.userPofile.type == "COMPANY") {
        this.isCompany = true;
        this.userInfo.avatarId = this.companyInfo.logo_id;
      } else {
        this.isCompany = false;
        this.userInfo.avatarId =
          this.employeeInfo.image_id ? this.employeeInfo.image_id :
          this.employeeInfo.administrative_info.avatar_id ? this.employeeInfo.administrative_info.avatar_id : undefined;
      }
    }
  },
  created() {
    this.getUserInfo();
  }
}
</script>
<style lang="scss" scoped>
h1, h2, h3, h4, h5, h6, p, span {
  font-family: 'Roboto';
}
.user-info{
  .user-info-top {
    padding: 15px 0 10px 0;
    display: flex;
    justify-content: space-between;
    .user-info-top__left{
      display: flex;
      align-items: center
    }
    .user-info-top__right{
      &:hover {
        cursor: pointer;
      }
      .el-dropdown-link{
        display: flex;
        align-items: center;
        .el-icon-arrow-down {
          &.el-icon--right{
            font-size: 19px;
            font-weight: bold;
            color: var(--color-icon);
          }
        }
      }
    }
  }
  .user-info-main{
    display: flex;
    align-items: center;
    flex-direction: column;
    p {
      color: #322C2C;
      font-weight: 700;
    }
    .user-avatar {
      &:hover {
        cursor: pointer;
      }
      .el-image {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        border: 1px solid #E5E5E5;
      }
    }
    .name {
      font-size: 16px;
      line-height: 25px;
      text-align: center;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      &:hover {
        cursor: pointer;
      }
    }
    .position{
      font-size: 13px;
      line-height: 19px;
    }
  }
  .user-info-contact{
    padding: 15px 20px 9px 20px;
    .user-info-contact__text {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
      .type {
        font-weight: 300;
        font-size: 14px;
        line-height: 130%;
      }
      .text {
        font-weight: 600;
        font-size: 14px;
        line-height: 130%;
        text-align: right;
        &.email{
          white-space: nowrap;
          text-align: right;
          width: 175px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
